/**
 * A date (or a date column's label) with a hover explanation of which date it
 * is — uploaded to Franklin, or taken from the file's own metadata. The two are
 * easy to confuse, and both appear in the document lists.
 */

import type { ReactNode } from "react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface DateHintProps {
  hint: string;
  children: ReactNode;
  side?: "top" | "bottom";
  className?: string;
}

export function DateHint({ hint, children, side = "top", className }: DateHintProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("cursor-help", className)}>{children}</span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="z-50 max-w-xs whitespace-normal text-xs font-normal normal-case tracking-normal"
        >
          {hint}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
